module.exports = __webpack_public_path__ + "static/media/vison.d8e8774c.svg";